import { render, staticRenderFns } from "./about.vue?vue&type=template&id=b09e8d38&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&lang=css&"
import style1 from "./about.vue?vue&type=style&index=1&id=b09e8d38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09e8d38",
  null
  
)

export default component.exports